export const convertToEnglishNumber = (str) => {
  // convert persian digits [۰۱۲۳۴۵۶۷۸۹]
  var e = '۰'.charCodeAt(0);
  str = str.replace(/[۰-۹]/g, function (t) {
    return t.charCodeAt(0) - e;
  });

  // convert arabic indic digits [٠١٢٣٤٥٦٧٨٩]
  e = '٠'.charCodeAt(0);
  str = str.replace(/[٠-٩]/g, function (t) {
    return t.charCodeAt(0) - e;
  });
  return str;
};


export const round = (x, n) =>
  parseFloat(Math.round(x * Math.pow(10, n)) / Math.pow(10, n)).toFixed(n);


  export const StrHasNoLetter = (str) => {
    let res = true;
    for (let s of str) {
      res = isLetter(s);
      if (res === false) {
        return false;
      }
    }
    return true;
  };
export  const isLetter = (chr) => {
    if (
      chr === ')' ||
      chr === '(' ||
      chr === '*' ||
      chr === '/' ||
      chr === '-' ||
      chr === '+' ||
      chr === '^' ||
      chr === '.' ||
      chr === '0' ||
      chr === '1' ||
      chr === '2' ||
      chr === '3' ||
      chr === '4' ||
      chr === '5' ||
      chr === '6' ||
      chr === '7' ||
      chr === '8' ||
      chr === '9'
    ) {
      return true;
    } else {
      return false;
    }
  };
  
 
  
  